import React from 'react'
import PropTypes from 'prop-types'

/**
 * FormStepHeader component for displaying the step number and title for each step in a form.
 * It can also render children components if provided.
 */
const FormStepHeader = ({ children, step, title }) => {
  return (
    <>
      <div className='font-semibold mt-8 mb-4 border-neutral-pri border-solid border-b border-t-0 border-r-0 border-left-0'>
        <span className='py-3 px-4 bg-brand-sec text-neutral-pri-con mr-3 inline-block'>{step}</span>
        {title}
      </div>
      {children && (
        <div className='w-full md:w-3/5'>
          {children}
        </div>
      )}
    </>
  )
}

FormStepHeader.propTypes = {
  children: PropTypes.node,
  step: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
}

export default FormStepHeader;